import {defineStore} from 'pinia'
export const useUserStore = defineStore('user', {
  state: () => {
    return {
      userInfo: {}
    }
  },
  getters: {
    _userInfo: state => state.userInfo,
  },
  actions: {
    setUserInfo(obj) {
      this.userInfo = Object.assign({}, obj)
    },
  },
})
